import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-order-line-cancel-causes',
  templateUrl: './order-line-cancel-causes.component.html',
  styleUrls: ['./order-line-cancel-causes.component.css']
})
export class OrderLineCancelCausesComponent implements OnInit {
    public itemsListCauses: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {

    }

    private async loadCauses() {
        this.itemsListCauses = await this.datatask.Post(3328);
    }

    public goToFunc(state: any) {
        switch (state) {
            case 'orderlinecancelcause':
                this.stateService?.go('orderlinecancelcause', { orderlinecancelcause_keyno: '0' });
                break;
            default:
                break;
        }
    }

    private async init() {
        this.loadCauses();
    }

    ngOnInit() {
        this.init();
    }
}



//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('orderLineCancelCauses', {
//        templateUrl: 'views/components/views/orderLineCancelCauses/orderLineCancelCauses.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'orderLineCancelCausesService', function (stateService, orderLineCancelCausesService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;

//            vm.model = {
//                itemsListCauses: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadCauses() {
//                vm.model.itemsListCauses = await orderLineCancelCausesService.listOrderLineCancelCauses();
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region MULTI DIRECTION BUTTON FUNCTIONS

//            vm.goToFunc = function (state, e) {
//                function go(parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                }

//                switch (state) {
//                    case 'orderlinecancelcause':
//                        go({ orderlinecancelcause_keyno: '0' });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadCauses();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
